module.exports = __webpack_public_path__ + "static/media/7ICJ3.4973f351.jpg";